import React from 'react';

import { HelpPanelTopicOptions } from '../common/Constants';

export interface HelpPanelContextData {
    panelTopic: HelpPanelTopicOptions;
    isPanelOpen: boolean;
    panelOpen: () => void;
    panelClose: () => void;
    panelHidden: () => void;
    panelHandler: (topic: HelpPanelTopicOptions) => void;
}

export const HelpPanelContext = React.createContext<HelpPanelContextData>({
    panelTopic: HelpPanelTopicOptions.DEFAULT,
    isPanelOpen: false,
    panelClose: () => {},
    panelOpen: () => {},
    panelHidden: () => {},
    panelHandler: () => {},
});
